import React, { Component } from 'react';
import '../../node_modules/font-awesome/scss/font-awesome.scss';

class MobileApp extends Component {
    render() {
        return (
        <div style={{color: 'white'}}>Sorry, this site is only available on desktop devices</div>
        );
    }
}

export default MobileApp;